// extracted by mini-css-extract-plugin
export default {"root":"FAQItem_root__kcQdR","accordionContent":"FAQItem_accordionContent__fBxXm","title":"FAQItem_title__KvizL"};